import styled from 'styled-components';
import { media, colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Card from '@bitcoin-portal/bitcoincom-pkg-components/dist/Card';

export const StyledCard = styled(Card)`
  margin: 0px ${({ theme }) => theme.spacing.unit * 3}px;

  max-width: 1027px;
  margin: auto;

  & > div {
    grid-column-gap: 80px;
    grid-row-gap: 40px;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;

    ${media.md`
      justify-content: space-between;
      align-items: center;
    `}
  }
`;

export const Apps = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 16px;

  & > a {
    display: flex;
    width: auto;
  }
`;

export const Content = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;

  align-items: center;
  text-align: center;

  ${media.md`
    align-items: flex-start;
    text-align: left;
  `}
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column nowrap;
  text-align: center;

  & > h5 {
    order: 1;
  }

  & > div {
    order: 0;
    padding: 10px 20px;
  }

  ${media.md`
  text-align: left;

    & > h5 {
      order: 0;
    }

    & > div {
      order: 1;
      padding: 10px 0;
    }
  `}
`;

export const CounterWrapper = styled.p`
  margin: 0;
  padding-bottom: 1em;
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  color: ${colors.solid.textOne};

  & > span > span {
    font-weight: 900;
    color: ${colors.solid.primaryBlue};
  }

  ${media.md`
    font-size: 18px;
    line-height: 28px;

    & > span > span {
      font-size: 20px;
      line-height: 34px;
    }
  `}

  ${media.xl`
    font-size: 24px;
    line-height: 32px;

    & > span > span {
      font-size: 24px;
      line-height: 32px;
    }
  `}
`;
